import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Check, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const perks = ["nl.p1", "nl.p2", "nl.p3"];

export const Newsletter = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) return toast.error("Devi accettare l'informativa privacy.");
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email, consent });
      setDone(true);
      toast.success("Iscrizione confermata!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Iscrizione non riuscita, riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="bg-[#F3EFE6] pb-24 lg:pb-40 pt-4">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <Reveal>
          <div className="bg-[#FBF9F5] border border-[#E6DFD3] p-8 sm:p-12 lg:p-16 grid lg:grid-cols-12 gap-10 lg:gap-16">
            <div className="lg:col-span-6">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#9A4930]">{t("nl.eyebrow")}</p>
              <h2 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
                {t("nl.h2a")} <em className="text-[#9A4930]">{t("nl.h2em")}</em>{t("nl.h2b")}
              </h2>
              <ul className="mt-8 space-y-3 text-[#57534E]">
                {perks.map((p) => (
                  <li key={p} className="flex items-center gap-3 text-sm md:text-base">
                    <Check className="w-4 h-4 text-[#6B7A63] shrink-0" /> {t(p)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:col-span-6 flex flex-col justify-center">
              {done ? (
                <div data-testid="newsletter-success" className="text-center py-8">
                  <span className="mx-auto w-14 h-14 rounded-full bg-[#6B7A63]/10 flex items-center justify-center">
                    <Check className="w-7 h-7 text-[#6B7A63]" />
                  </span>
                  <p className="mt-5 font-serif text-3xl text-[#1C1917]">{t("nl.ok_t")}</p>
                  <p className="mt-2 text-sm text-[#57534E]">{t("nl.ok_p").replace("{email}", email)}</p>
                </div>
              ) : (
                <form onSubmit={submit} data-testid="newsletter-form" className="space-y-6">
                  <label className="block">
                    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#57534E]">{t("nl.label")}</span>
                    <input
                      data-testid="newsletter-input-email"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t("nl.ph")}
                      className="field"
                    />
                  </label>
                  <label className="flex gap-3 items-start cursor-pointer text-sm text-[#57534E] leading-snug">
                    <input type="checkbox" data-testid="newsletter-consent-checkbox" className="mt-1 accent-[#9A4930] w-4 h-4" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
                    <span>
                      {t("nl.consent_a")} <Link to="/privacy" className="underline underline-offset-2 hover:text-[#9A4930] whitespace-nowrap">{t("nl.consent_link")}</Link>{t("nl.consent_b")}
                    </span>
                  </label>
                  <button type="submit" disabled={loading} data-testid="newsletter-submit-button" className="btn-pill bg-[#29221D] text-[#FBF9F5] disabled:opacity-60 w-full sm:w-auto justify-center">
                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} {t("nl.send")} <ArrowRight className="w-4 h-4" />
                  </button>
                </form>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
